import { EOL, EOS } from 'client/util/Constants/ApplicationConstants';

const ApplicationsTemplatesFilters = {
  // Application Status
  appStatusEos: () => ({
    id: EOS,
    name: 'status',
    operator: 'ne',
    value: EOS,
  }),
  appStatusEol: () => ({
    id: EOL,
    name: 'status',
    operator: 'ne',
    value: EOL,
  }),
};

export default ApplicationsTemplatesFilters;
